import { Heart, ShieldCheck, Sparkles } from "lucide-react";
import Reveal from "./Reveal";
import { IMAGES } from "../data/site";

const VALUES = [
  { icon: Sparkles, title: "Kvalitet först", desc: "Vi levererar kristallklart – och nöjer oss aldrig med 'tillräckligt bra'." },
  { icon: Heart, title: "Engagemang", desc: "Vi bryr oss om ditt hem och din verksamhet som om det vore vårt eget." },
  { icon: ShieldCheck, title: "Trygghet", desc: "Försäkrade, punktliga och alltid tydliga med pris och förväntningar." },
];

export const WorkGallery = () => (
  <section id="om-oss" className="bg-white scroll-mt-24" data-testid="work-gallery">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* IMAGES — editorial asymmetric composition */}
        <div className="lg:col-span-7 relative">
          <Reveal>
            <div className="overflow-hidden rounded-[2rem] shadow-[0_30px_60px_-20px_rgba(7,22,44,0.25)] group">
              <img
                src={IMAGES.afterUterum}
                alt="Se Klart Ut – skinande rent uterum efter fönsterputs"
                className="w-full aspect-[4/5] md:aspect-[5/6] object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
                loading="lazy"
              />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="hidden md:block absolute -bottom-12 -right-4 lg:-right-10 w-56 lg:w-64 overflow-hidden rounded-3xl border-8 border-white shadow-[0_25px_50px_-15px_rgba(7,22,44,0.3)] group">
              <img
                src={IMAGES.workTwo}
                alt="Se Klart Ut – kristallklart fönster efter putsning"
                className="w-full aspect-[3/4] object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.05]"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>

        {/* ABOUT COPY */}
        <div className="lg:col-span-5 md:pt-8">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand-blue">Om oss</p>
          </Reveal>
          <Reveal delay={0.06}>
            <h2 className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-brand-ink leading-tight">
              Lokalt från Skövde – <span className="font-accent italic font-semibold text-brand-blue">i hela Skaraborg.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-5 text-lg text-slate-600 leading-relaxed">
              Se Klart Ut grundades med en enkel idé: att utvändig rengöring kan vara både prisvärd och premium. Fönsterputs är vår kärntjänst, men vi hjälper dig med mer av utsidan – solpaneler, altan och mark.
            </p>
          </Reveal>
          <div className="mt-8 space-y-5">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={0.15 + i * 0.07}>
                <div className="flex items-start gap-4">
                  <span className="h-10 w-10 rounded-full bg-brand-iceBg border border-slate-100 flex items-center justify-center shrink-0">
                    <v.icon className="h-5 w-5 text-brand-blue" strokeWidth={1.75} />
                  </span>
                  <div>
                    <p className="font-semibold text-brand-ink">{v.title}</p>
                    <p className="text-sm text-slate-500 mt-0.5 leading-relaxed">{v.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default WorkGallery;
